import React from 'react';

import { ReactComponent as Icon } from '../../../../assets/icons/transmission-automatic.svg';

export default function TransmissionAutomaticIcon(props: React.SVGProps<SVGSVGElement> & { display?: string }) {
    return <Icon {...props} />;
}
